import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import AppLink from "../../../../components/AppLink";
import RelicAvatar from "../../../../components/RelicAvatar";
// import {} from 'loadash'
import { blue } from "@mui/material/colors";

import { Agent } from "../../../../models";
import { titleCase } from "../../../../helpers";

const AgentView: React.FC<{
  agent: Agent;
  show: boolean;
  onClick?: () => void;
}> = ({ agent, show, onClick }) => {
  return (
    <Box
      sx={{
        minWidth: "250px",
      }}
    >
      <Box display="flex" sx={{ mb: 2 }}>
        <RelicAvatar size={60} avatarBgColor={blue[500]} user={agent} display />

        <div style={{ paddingLeft: "1em" }}>
          <Typography
            fontWeight={"bold"}
            sx={{
              mr: 1,
            }}
          >
            {titleCase(`${agent.Name}`)}
          </Typography>

          <Typography color="inherit" fontSize={"14px"} fontWeight={400}>
            {agent.Email}
          </Typography>
          {!!onClick && (
            <Button
              variant="outlined"
              color={"success"}
              sx={{
                mr: 1,
              }}
              onClick={onClick}
            >
              Restore
            </Button>
          )}
          {show && <AppLink to={"/agents/view/" + agent.id}>View</AppLink>}
        </div>
      </Box>

      <div
        style={{
          padding: "1em",
          borderRadius: "24px",
          border: "1px solid rgba(107, 119, 154, 0.1)",
        }}
      >
        <Typography component="h6" variant="h6" fontWeight={"bold"}>
          User Info
        </Typography>
        <Grid
          container
          spacing={1}
          style={{
            marginBottom: "12px",
          }}
        >
          <Grid item xs={4}>
            <div className="name-item">
              <Typography variant="subtitle1">Gender</Typography>
              <Typography fontWeight={"bold"}>{agent.Sex}</Typography>
            </div>
          </Grid>

          <Grid item xs={4}>
            <div className="name-item">
              <Typography variant="subtitle1">Age</Typography>
              <Typography fontWeight={"bold"}>25 years</Typography>
            </div>
          </Grid>

          <Grid item xs={4}>
            <div className="name-item">
              <Typography variant="subtitle1">Discipline</Typography>
              <Typography fontWeight={"bold"}>Agent</Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default AgentView;
